import { Injectable } from '@angular/core';
import { UserNewDataService } from './usernew-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserNewMockService implements UserNewDataService {
  readonly responseUserNew = {
    data: {
      code: 200
    }
  };
  readonly responseUserNewError = {
    errorData: {
      data: {
        statuscode: 400
      }
    }
  };
  counter = 0;

  postUserNew(): Promise<any> {
    this.counter = this.counter + 1;

    if (this.counter <= 2) {
      return new Promise(resolve => setTimeout(() => resolve(this.responseUserNewError), 2000));
    } else {
      return new Promise(resolve => setTimeout(() => resolve(this.responseUserNew), 2000));
    }
  }

}
